/**
 * Aoria — logotype officiel (signature typographique).
 *
 * Le logo est désormais un wordmark PNG (extrait du fichier maître fourni
 * par la direction d'Aoria). Plus de pictogramme : la signature est
 * exclusivement typographique.
 *
 * Deux variantes :
 *   - aoria-logo-black.png pour fonds clairs (couleur #0D1B2A, bleu nuit)
 *   - aoria-logo-white.png pour fonds sombres (couleur #FDFDFC)
 *
 * Le composant prend une hauteur (en px) et calcule la largeur via le ratio
 * d'aspect du wordmark (≈ 2.85:1) pour garantir un rendu net à toutes les
 * tailles (CSS height fixe, width=auto).
 */

const ASPECT = 565 / 198; // ratio largeur/hauteur du PNG master

const presets = {
    // Hauteurs en px (la largeur est calculée automatiquement)
    sm: 22,
    md: 30,
    lg: 56,
    xl: 96,
};

export default function Logo({
    size = "md",
    tone = "dark",
    className = "",
    "data-testid": testId = "aoria-logo",
}) {
    const px = typeof size === "number" ? size : presets[size] || presets.md;
    const width = Math.round(px * ASPECT);
    const src =
        tone === "light"
            ? "/aoria-logo-white.png"
            : "/aoria-logo-black.png";

    return (
        <img
            data-testid={testId}
            src={src}
            alt="Aoria"
            width={width}
            height={px}
            decoding="async"
            loading="eager"
            className={`block select-none ${className}`}
            style={{ height: px, width }}
        />
    );
}

/**
 * Compat layer : certains emplacements (page d'identité, anciens imports)
 * importent `{ AoriaMark }`. On expose un alias qui rend simplement le
 * logotype (couleur héritée par tone), pour éviter toute régression.
 */
export function AoriaMark({ size = 28, className = "", tone = "dark" }) {
    return <Logo size={size} tone={tone} className={className} />;
}
